export default {
  default: () => import("/Users/duncandeklerk/Dev/ProjectsVue/airabica/airabica-nuxtapp/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/Users/duncandeklerk/Dev/ProjectsVue/airabica/airabica-nuxtapp/layouts/empty.vue").then(m => m.default || m)
}